<template>
  <div>
    <img
      @click="setAuctionModal"
      :src="artwork.imagePreviewUrl"
      :alt="artwork.name"
    />
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';

  export default {
    name: 'ArtworkImage',
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    methods: {
      ...mapMutations(['SET_ACTIVE_MODAL_AUCTION_ID']),
      setAuctionModal() {
        this.SET_ACTIVE_MODAL_AUCTION_ID(this.internetAuction.id);
      },
    },
    computed: {
      artwork() {
        return this.internetAuction.artwork;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/artwork/artwork_image.vue?5191aa1a